/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)
import BackToTop from "./Classes/BackToTop";
import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import XDownloader from "./Classes/XDownloader";
import Header from "./Classes/Header";
import Home from "./Classes/Home";
import Video from "./Classes/Video";
import LinkHandler from "./Classes/LinkHandler";
import FootnoteIcons from "./Classes/FootnoteIcons"

import CssHeights from "./Classes/CssHeights";
// import ScrollToTop from './Classes/ScrollToTop';

import Accordion from './Classes/Accordion';
import AnchorScroll from "./Classes/AnchorScroll";
import ScrollToNextElement from "./Classes/ScrollToNextElement";

import Accordion3columns from "./Classes/Accordion-3columns";
import Animate from "./Classes/Animate";
import InteractiveGraphic from "./Classes/InteractiveGraphic";
import Cv from "./Classes/Cv";
import ScrollDown from "./Classes/ScrollDown";
import Slider from './Classes/Slider';
import InteractiveSvg from './Classes/InteractiveSvg';
import xdownloaderConfig from "./xdownloader-config";
import Sharing from "./Classes/Sharing";
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";

// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';

var backToTopInstance = null;
var focusHandlerInstance = null;
var lazyLoadInstance = null;
var downloaderInstance = null;
var headerInstance = null;
var accordionInstance = null;
var jumpInstance = null;
var accordion3columns = null;
var youtubeLinksInstance = null;
var anchorContainerInstance = null;
var scrollToNextElementInstance = null;
var videoInstance = null;
var homeInstance = null;
var cssHeightsInstance = null
var animateInstance = null;
var interactiveLinksInstance = null;
var cvInstance = null;
var sliderInstance = null;
var scrollDownInstance = null
var interactiveSvgInstance = null
var linkHandler = null;
var sharingInstance = null;
var responsiveTablesLight = null;
var footnoteIcons = null;
export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();

  responsiveTablesLight = new ResponsiveTablesLight({
    tableComponentSelector: '.lc-table-wrap',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-table-wrap table'
  });

  footnoteIcons = new FootnoteIcons()

  anchorContainerInstance = new AnchorScroll({
    containerSelector: '.ns-anchor'
  });

  scrollToNextElementInstance = new ScrollToNextElement({
    buttonSelector: '.js-header-img-button'
  });

  /*
  Highcharts.setOptions({
    lang: {
      decimalPoint: '.', // default: '.'
      numericSymbols: ["k", "M", "G"], // default: ["k", "M", "G", "T", "P", "E"], set to null to see full numbers
      numericSymbols: ["k", "M", "G"], // default: ["k", "M", "G", "T", "P", "E"], set to null to see full number
      thousandsSep: '\u0020', // default: '\u0020'
      shortMonths: ["Jan", "Feb", "Mar"], // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }
  });
  */

  downloaderInstance = new XDownloader(xdownloaderConfig);

  headerInstance = new Header();

  homeInstance = new Home();
  linkHandler = new LinkHandler();
  animateInstance = new Animate();

  backToTopInstance = new BackToTop({
    buttonClass: '.js-backtotop-toggle',
    stickyClass: '.prev-next__inner',
    fadeInPosition: 100,
    correction: 0,
    toolbarClass: '.js-backtotop-toggle'
  });


  const img = document.querySelector('.ns-image')

  sharingInstance = new Sharing();


  accordionInstance = new Accordion({
    accordions: '.ns-accordion__head',
    pxCorrection: -50
  });

  accordion3columns = new Accordion3columns({
    accordions: '.ns-three-col-container__item'
  })


  videoInstance = new Video();
  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

  interactiveLinksInstance = new InteractiveGraphic();
  cvInstance = new Cv();
  scrollDownInstance = new ScrollDown();

  interactiveSvgInstance = new InteractiveSvg();

  sliderInstance = new Slider();
});

